import { Treemap, Tooltip } from 'recharts';




const TreemapComponent = (props) => {

  const COLORS = ['#3b6cf4', '#6366f1', '#0d9488', '#14b8a6', '#f59e0b', '#f97316'];

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload) {
      return (
        //pour etre centre verticalement, doit etre un span
        <div className="custom-tooltip-treemap">
          <span className="label-treemap">Code : {payload[0] ? payload[0].payload.name : ''}<br />
            Total pts : {payload[0] ? payload[0].payload.totalpts : ''}</span>
        </div>
      );
    }

    return null;
  };

  const CustomizedContent = (props) => {

    const {
      depth, x, y, width, height, index, colors, name, totalpts
    } = props;

    return (
      <g>
        <rect
          x={x}
          y={y}
          width={width}
          height={height}
          style={{
            //fix ici : le 3 correspond au nombre de categories (chirurgie, biospsie, autres = 3)
            fill: depth < 2 ? colors[Math.floor(index / 3 * 6)] : 'rgba(255,255,255,0)',
            stroke: '#fff',
            strokeWidth: 2 / (depth + 1e-10),
            strokeOpacity: 1 / (depth + 1e-10),
          }}
        />
        {
          depth === 1 ? (
            <text
              x={x + width / 2}
              y={y + height / 2 + 7}
              textAnchor="middle"
              fill="#fff"
              fontSize={18}
              fontFamily="Roboto"
              fontWeight={300}
            >
              {name}
            </text>
          ) : null
        }
        {
          depth === 3 && totalpts > 100 ? (
            <text
              x={x + width / 2 - 6}
              y={y + height / 2}
              fill="#fff"
              fontSize={8}
              fillOpacity={0.8}
              fontFamily="Roboto"
              fontWeight={100}
            >
              {name}
            </text>
          ) : null
        }
      </g>
    );
  };

  return (

    <Treemap
      width={1000}
      height={500}
      data={props.treeData}
      dataKey="totalpts"
      aspectRatio={4 / 3}
      stroke="#fff"
      fill="#8884d8"
      content={<CustomizedContent colors={COLORS} />}
    >
      <Tooltip
        content={<CustomTooltip />}
      />
    </Treemap>

  );

};


export default TreemapComponent;